<template>
	<el-select
		v-model="searchValue"
		class="select-box"
		filterable
		clearable
		:collapse-tags="collapseTags"
		:multiple-limit="10"
		:multiple="multiple"
		:placeholder="placeholder"
		@change="changeSelect"
		v-loadMore="loadMore"
	>
		<el-option v-for="item in list" :key="item.id" :label="item.tag_name" :value="item.id" />
		<div class="align-center bottom pt-8 pb-8 yx-color-text-secondary fz-12" v-if="!noMore">
			{{ noMore ? '到底了~' : '加载中' }}
		</div>
	</el-select>
</template>

<script>
import { tagsList } from '@/api/shopManage';
export default {
	props: {
		value: [Array, String],
		multiple: {
			type: Boolean,
			default: true,
		},
		arr: {
			type: [Array],
			default: () => [],
		},
		returnArray: {
			type: Boolean,
			default: false,
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
	},
	watch: {
		value: {
			handler(val) {
				this.searchValue = val;
			},
			deep: true,
			immediate: true,
		},
	},
	data() {
		return {
			list: [],
			searchValue: '',
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
			total: '0',
			noMore: true,
		};
	},
	created() {
		const { multiple } = this;
		let id = this.$route.query.id || '';
		if (multiple) {
			if (id) (this.searchValue = [id]), this.changeSelect(this.searchValue);
		}
		this.getList();
	},
	methods: {
		async getList(e = '', type = 0) {
			const {
				code,
				data: { list = [], page = {} },
			} = await tagsList({ ...this.pageInfo, tag_name: e });
			if (code !== 0) return;
			this.loading = false;
			this.total = `${page.item_total}`;
			this.list = type ? this.list.concat(list) : list;
		},
		loadMore() {
			let num = Math.ceil(this.total / this.pageInfo.page_size);
			if (num <= this.pageInfo.page_index) return (this.noMore = true);
			this.noMore = false;
			this.pageInfo.page_index++;
			this.getList(this.searchValue, 1);
		},
		changeSelect(e) {
			this.$emit('input', e);
		},
		reset() {
			this.searchValue = '';
		},
	},
};
</script>
<style lang="less" scoped>
.bottom {
	border-top: 1px solid #ddd;
}
</style>